"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CASH_THRESHOLD = void 0;
exports.CASH_THRESHOLD = 5000;
//# sourceMappingURL=const.js.map